import {HttpClient} from '@angular/common/http';
import {Component} from '@angular/core';
import {User} from '../../classes/User';
import {LocalStorageService} from '../../services/local-storage.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-phone-verification',
  styleUrls: ['./phone-verification.component.scss'],
  templateUrl: './phone-verification.component.html',
})
export class PhoneVerificationComponent {

  public form: any = {};
  public codeForm: any = {};
  public currentUser: User;
  public isSuccessful = false;
  public errorMessage: string;
  public activationCode: string;
  public isActivated = false;

  constructor(private httpClient: HttpClient,
              private localStorageService: LocalStorageService) {
    this.currentUser = this.localStorageService.getUser();
  }

  public sendSms(): void {
    this.httpClient.get(`${environment.backendApiUrl}/v1/users/phone/verification_code`)
      .subscribe({
        next: () => {
          this.isSuccessful = true;
        },
        error: (err) => {
          this.isSuccessful = false;
          this.errorMessage = err.error.message;
        },
      });
  }

  public onSubmitCode(): void {
    this.httpClient.get(`${environment.backendApiUrl}/v1/users/phone/verify?code=` + this.activationCode)
      .subscribe({
        next: () => {
          this.isActivated = true;
        },
        error: (err) => {
          this.isActivated = false;
          this.errorMessage = err.error.message;
        },
      });
  }
}
